import React from 'react';
import PropTypes from 'prop-types';
import { TestimonialsSection } from '../TestimonialsSection';
import styles from './ImageCardsSection.css';

function ImageCardsSection({ title, imageSrc, children, withTestimonials }) {
    return (
        <section className={styles.root}>
            <div className={styles.container}>
                <div className={styles.imageBox}>
                    <h2 className={styles.title}>{title}</h2>
                    <div className={styles.mediaCardsGroup}>
                        <div className={styles.media} style={{ '--image-src': `url(${imageSrc})` }} />
                        <ul className={styles.cards}>{children}</ul>
                    </div>
                </div>
                {withTestimonials && <TestimonialsSection />}
            </div>
        </section>
    );
}

ImageCardsSection.propTypes = {
    title: PropTypes.string.isRequired,
    imageSrc: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    withTestimonials: PropTypes.bool
};

ImageCardsSection.defaultProps = {
    withTestimonials: false
};

export {
    ImageCardsSection
};
